<template>
    <div class="text-xl md:text-2xl mt-4">
        Owning a car is safer and more rewarding when you have <span class="font-semibold">Carbucks.</span>
    </div>
</template>